export const getTenantPrefix = () => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  return pathSegments.length > 0 ? pathSegments[0] : null; // Return null if no tenant prefix
};
